import $ from 'jquery';
import { View } from 'backbone';
import Template from 'report/properties/main/filter.ejs';

class MainFilterView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            "change input[type=checkbox]"   : "updateCheckAttributes"
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal  = ev.currentTarget.checked;

        if(propName === "additiveDynamicFilter"){
            propVal = !propVal;
        }

        this.model.set( propName, propVal );
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        this.delegateEvents();
        return this;
    }

}

export default MainFilterView;
